import { render } from "./HeaderComp.vue?vue&type=template&id=34da13a6&scoped=true"
import script from "./HeaderComp.vue?vue&type=script&lang=js"
export * from "./HeaderComp.vue?vue&type=script&lang=js"

import "./HeaderComp.vue?vue&type=style&index=0&id=34da13a6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\gigae\\projects\\ecommerce\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34da13a6"]])

export default __exports__